/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Single-series records-per-day trend for the activity-log pages (036), on the
 * shared au-panel system (mirrors 028/030/034/035). Coral line, text-labelled
 * legend, per-point tooltip (exact date + count), graceful single-day/empty handling.
 * The per-day sum reconciles 1:1 with the Logs card.
 *
 * Props: { data:[{date:'YYYY-MM-DD',count:int}], title, seriesName }
 */
const shortDate = (d) => (d ? String(d).split('-').slice(1).reverse().join('/') : '');

const ActivityLogTrendChart = ({ data = [], title = 'Logs per day', seriesName = 'Logs' }) => {
  const enough = Array.isArray(data) && data.length >= 2;

  return (
    <div className="au-panel" data-testid="al-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">{title}</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i style={{ background: '#f26b45' }} />{seriesName}</span>
        </div>
      </div>

      {enough ? (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(value) => [Number(value).toLocaleString(), seriesName]}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="count" name={seriesName} stroke="#f26b45" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="al-trend-empty">
          Not enough data to plot a trend (need at least 2 days).
        </div>
      )}
    </div>
  );
};

export default ActivityLogTrendChart;
